import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Material UI Components
import { Box, Paper, Toolbar, IconButton, Divider, Button, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip, TextField } from '@material-ui/core';

// Icons
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import InsertPhotoIcon from '@material-ui/icons/InsertPhoto';
import BuildIcon from '@material-ui/icons/Build';

const useStyles = makeStyles(theme => ({
    Toolbar: {
        width: "100%",
        minHeight: "56px",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    Divider: {
        alignSelf: 'stretch',
        height: 'auto',
        margin: theme.spacing(1, 2)
    },
}));

export default function StaticToolbar( {editorState, editMode, onClickUndo, onClickRedo, onClickToggleImageUrl, onClickInsertCanvas, onClickClearEditor} ) {
    const Style = useStyles();
    const [hidden, setHidden] = React.useState(true);
    const [undo, setUndo] = React.useState(false);
    const [redo, setRedo] = React.useState(false);

    const undoStack = editorState.getUndoStack();
    const redoStack = editorState.getRedoStack();

    // console.log();
    
    React.useEffect(() => {
        if(editMode === true){
            setHidden(false);
        }else{
            setTimeout(() => {
                setHidden(true);
            }, 750)
        }

        if(undoStack.length < 1){
            setUndo(false);
        }else{
            setUndo(true);
        }

        if(redoStack.length < 1){
            setRedo(false);
        }else{
            setRedo(true);
        }
    }, [editMode, undoStack, redoStack])

    // Dialog
    const [open, setOpen] = React.useState(false);
    const [url, setURL] = React.useState('');
    // const [urlValid, setUrlValid] = React.useState('');

    // This method will open the dialog
    const handleClickOpen = () => {
        setOpen(true);
    };

    // This method will close the dialog
    const handleClose = () => {
        setOpen(false);
    };

    // This method will toggle an image to the url given
    const handleURL = () => {
        handleClose()
        onClickToggleImageUrl(url)
    }

    /*
        This method will handle the keypress. If enter then it will execute the handleURL method 
        else if the escape key is pressed it will execute the handleClose method
    */
    const handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            handleURL()
        } else if(event.key === 'Escape'){
            handleClose()
        }
    }

    return (
        <React.Fragment>
            <Box mb={2} className={editMode === true ? 'animated fadeIn' : 'animated fadeOut'} hidden={hidden}>
                <Paper variant="outlined" className={Style.Paper}>
                    <Toolbar className={Style.Toolbar}>
                        <Tooltip title={undo === false ? "" : "UNDO"} placement="bottom">
                            <span>
                                <IconButton aria-label="Undo" color="inherit" edge="start" onClick={() => onClickUndo()} disabled={undo === false ? true : false}>
                                    <UndoIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title={redo === false ? "" : "REDO"} placement="bottom">
                            <span>
                                <IconButton aria-label="Redo" color="inherit" edge="end" onClick={() => onClickRedo()} disabled={redo === false ? true : false}>
                                    <RedoIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="INSERT IMAGE" placement="bottom">
                            <IconButton aria-label="Insert Image" color="inherit" style={{marginLeft: "16px"}} onClick={() => handleClickOpen()}>
                                <InsertPhotoIcon />
                            </IconButton>
                        </Tooltip>
                        <Divider className={Style.Divider} orientation="vertical" />
                        <Button aria-label="Clear Editor" color="secondary" variant="outlined" onClick={() => onClickClearEditor()}>Clear</Button>
                    </Toolbar>
                </Paper>
            </Box>
            <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alertTitle"
        >
            <DialogTitle id="alertTitle">Enter URL</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="url"
                    label="URL"
                    placeholder="www.google.com"
                    type="text"
                    onChange={(event) => setURL(event.target.value)}
                    onKeyPress={(event) => handleKeyPress(event)}
                    variant="outlined"
                    required
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Cancel
                </Button>
                <Button disabled={url === "" ? true : false} onClick={handleURL} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    </React.Fragment>
)}